import React, {useEffect, useState} from 'react';
import {useLazyQuery} from '@apollo/client';
import {useField, useFormikContext} from 'formik';
import AutoField, {ActionType, SelectAutocompleteField} from '../AutoForm/AutoFieldNew';
import withAutoFormNew from '../AutoForm/AutoFormNew';
import {GetAdvisors, GetAdvisors_staff} from '../../schema-types/GetAdvisors';
import {GET_ADVISER_QUERY} from '../../pages/ReviewsPage/reviewPageQueries';
import {SaltusAny} from '../../utils/SaltusAny';

type AdvisorSearchProps = {
  onStaffChange: (staff: GetAdvisors_staff) => SaltusAny;
};

const AdviserSearchInner: React.FC<AdvisorSearchProps> = ({onStaffChange}) => {
  const [initialValue, setInitialValue] = useState<string | undefined>(() => {
    const storedValue = localStorage.getItem('selectedStaffId');
    return storedValue !== null ? storedValue : undefined;
  });

  const [query, {data: advisorsData, loading}] =
    useLazyQuery<GetAdvisors>(GET_ADVISER_QUERY);

  useEffect(() => {
    query();
  }, [query]);

  const {setFieldValue} = useFormikContext();

  useEffect(() => {
    if (initialValue !== undefined) {
      setFieldValue('staff', initialValue);
    }
  }, [initialValue, setFieldValue]);

  const field: SelectAutocompleteField = {
    type: ActionType.selectAutocomplete,
    id: 'staff',
    label: 'Search advisor',
    fullWidth: true,
    options:
      advisorsData?.staff?.map((x) => ({
        label: `${x.firstName!} ${x.lastName!}`,
        value: x.id,
      })) || [],
    loading,
  };

  const [{value}, , {setValue}] = useField('staff');

  useEffect(() => {
    if (value) {
      const staff = advisorsData?.staff?.find((x) => x.id === value);
      if (staff) {
        const selectedStaff = {
          __typename: staff.__typename,
          id: staff.id,
          firstName: staff.firstName,
          lastName: staff.lastName,
          email: staff.email,
        };
        localStorage.setItem('selectedStaffId', staff.id);
        onStaffChange(selectedStaff as any);
      }
    }
  }, [value, advisorsData]);

  return <AutoField field={field} />;
};

export const StaffSearchForm = withAutoFormNew(AdviserSearchInner, undefined, {
  debugPosition: 'bottom',
});
